// extracted by mini-css-extract-plugin
module.exports = {"formatted-text":"formatted-description_formatted-text__moW_o","formattedText":"formatted-description_formatted-text__moW_o"};